import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a67f59a6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\008-QLK_FE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a67f59a6')) {
      api.createRecord('a67f59a6', component.options)
    } else {
      api.reload('a67f59a6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a67f59a6&", function () {
      api.rerender('a67f59a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/work-submit/index.vue"
export default component.exports